import React, { useEffect, useMemo } from 'react'
import { Text } from '@mantine/core'

interface Winner {
  id: number
  name: string
  prize: string
  emoji: string
}

const RECENT_WINNERS: Winner[] = [
  { id: 1, name: '张**', prize: '1188元现金', emoji: '🎊' },
  { id: 2, name: '李**', prize: '888元现金', emoji: '💰' },
  { id: 3, name: '王**', prize: '188元现金', emoji: '🎁' },
  { id: 4, name: '赵**', prize: '50积分', emoji: '💎' },
  { id: 5, name: '刘**', prize: '积分奖励', emoji: '✨' },
  { id: 6, name: '陈**', prize: '现金红包', emoji: '🧧' },
]

interface WinnerAnnouncementsProps {}

const WinnerAnnouncements: React.FC<WinnerAnnouncementsProps> = () => {
  const duplicatedWinners = useMemo(() => {
    return [...RECENT_WINNERS, ...RECENT_WINNERS]
  }, [])

  useEffect(() => {
    const style = document.createElement('style')
    style.textContent = `
      @keyframes scrollMarquee {
        0% { transform: translateX(20%); }
        100% { transform: translateX(-50%); }
      }
      
      @keyframes subtleGlow {
        0%, 100% { opacity: 0.9; }
        50% { opacity: 1; }
      }
      
      .winner-marquee {
        will-change: transform;
        backface-visibility: hidden;
        transform: translateZ(0);
      }
      
      .winner-item {
        transform: translateZ(0);
      }
    `
    document.head.appendChild(style)

    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style)
      }
    }
  }, [])

  if (RECENT_WINNERS.length === 0) {
    return null
  }

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #FDD1BC 0%, #F5C79B 100%)',
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(253, 209, 188, 0.4)',
        border: '1px solid rgba(253, 209, 188, 0.6)',
        position: 'relative',
        overflow: 'hidden',
        height: 36,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div
        className="winner-marquee"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 32,
          whiteSpace: 'nowrap',
          animation: 'scrollMarquee 25s linear infinite',
          minWidth: 'max-content',
        }}
      >
        {duplicatedWinners.map((winner, index) => (
          <div
            key={`${winner.id}-${index}`}
            className="winner-item"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              minWidth: 'fit-content',
            }}
          >
            <span style={{ fontSize: 14 }}>{winner.emoji}</span>
            <Text
              size="sm"
              style={{
                color: '#8B4513',
                fontWeight: 600,
                fontSize: 13,
                animation: 'subtleGlow 3s ease-in-out infinite',
                animationDelay: `${index * 0.2}s`,
              }}
            >
              恭喜 <span style={{ color: '#D2691E', fontWeight: 700 }}>{winner.name}</span> 刮中{' '}
              <span style={{ color: '#FF6347', fontWeight: 700 }}>{winner.prize}</span>
            </Text>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WinnerAnnouncements
